import { extend, $$, addEvent } from './HelperFunctions'

export class Publication {
  constructor (selectors, classes) {
    this.selectors = extend({
      publication: '[data-js-publication]',
      btnMore: '[data-js-plublication-btn-more]'
    }, selectors)

    this.classes = extend({
      isMore: 'is--more'
    }, classes)

    this.$publications = $$(this.selectors.publication)
  }

  init () {
    this.addPublicationEvent()
  }

  addPublicationEvent () {
    this.$publications.forEach(publication => {
      const btnMores = $$(this.selectors.btnMore, publication)

      btnMores.forEach(btnMore => {
        addEvent(btnMore, 'click', (event) => {
          event.preventDefault()
          publication.classList.add(this.classes.isMore)
        })
      })
    })
  }
}

export default Publication
